import { gql } from '@apollo/client'

export const CUSTOMER_FRAGMENT = gql`
  fragment Customer on Customer {
    id
    additionalPhones
    birthday
    email
    firstName
    fullName
    isAnonymous
    lastName
    phone
    signedUp
    subscribed
    subscribedSms
    primaryAddress {
      id
    }
  }
`
